import MainContent from './_components/HomePage/MainContent';
import HomePageLayout from './_layout/HomePageLayout';

const Index = () => {
  return <MainContent />;
};
export default Index;

Index.getLayout = function getLayout(page: any) {
  return <HomePageLayout>{page}</HomePageLayout>;
};

Index.getInitialProps = () => {
  return {
    metadata: {
      className: 'DevSiteHomePageMetadata',
    },
  };
};
